import type { FunctionComponent } from 'react';
import ConceptsBar from './ConceptsBar';
import type { Round } from '../../store/PlaythroughSlice';

export interface StateProps {
	roundCount: number;
	finishedRounds: Round[];
	finishedRoundsCount: number;
}

export interface DispatchProps {}

export interface OwnProps {
	onConcepts?: () => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const ConceptsBarMapLayer: FunctionComponent<Props> = (props: Props) => {
	const { roundCount, finishedRounds, finishedRoundsCount, onConcepts } = props;

	return (
		<ConceptsBar
			roundCount={roundCount}
			finishedRounds={finishedRounds}
			finishedRoundsCount={finishedRoundsCount}
			onConcepts={onConcepts}
			position="absolute"
			right="3.2vmin"
			top="0"
		/>
	);
};

export default ConceptsBarMapLayer;
